import { authApi } from "./index";

export const getAllCountries = async () => {
  try {
    const response = await authApi.post("/Countries/get-all-countries");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getState = async (country) => {
  try {
    const response = await authApi.get(`/Countries/get-state?countryName=${encodeURIComponent(country)}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCitiesInAState = async (credentials) => {
  try {
    const response = await authApi.post("/Countries/get-cities-in-a-state", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};